module.exports = __webpack_public_path__ + "img/mn.584ff9bb.png";